/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterMaterial_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterMaterial_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterMaterial_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMaterial_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3e7dd755de266968a5dd4f9d293b4f11';
module.exports = node;
